import * as React from "react"

export default function ExhibitionIcon(props) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M29 31H3V29H29V31Z" fill={props.fill} />
      <path d="M28 27H4V25H28V27Z" fill={props.fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.877 7H23V10H21.0771L22.6787 14.0039C25.0811 14.0977 27 16.0746 27 18.5C27 20.9853 24.9853 23 22.5 23C20.0147 23 18 20.9853 18 18.5C18 16.6637 19.0999 15.0844 20.6768 14.3848L19.3232 11H18.5L16.8281 16.7334L16.3936 16.9189L13.9658 17.959C13.9871 18.1364 14 18.3168 14 18.5C14 20.9853 11.9853 23 9.5 23C7.01472 23 5 20.9853 5 18.5C5 16.5408 6.25234 14.8747 8 14.2568V13H6V11H12.1973L15.1973 9H18.5234L17.3232 6H15V4H18.6768L19.877 7ZM9.5 16C8.11929 16 7 17.1193 7 18.5C7 19.8807 8.11929 21 9.5 21C10.8807 21 12 19.8807 12 18.5C12 17.1193 10.8807 16 9.5 16ZM22.5 16C21.1193 16 20 17.1193 20 18.5C20 19.8807 21.1193 21 22.5 21C23.8807 21 25 19.8807 25 18.5C25 17.1193 23.8807 16 22.5 16ZM12.8027 13H10V14.0283C11.3814 14.1811 12.5729 14.9592 13.2881 16.0732L15.1719 15.2666L16.417 11H15.8027L12.8027 13Z"
        fill={props.fill}
      />
    </svg>
  )
}